var BudgetStrings = {
    maxAmountValidationMessage: function (max) {
        return "Team plans have a maxmium spending limit of $" + max + ". For higher spending limits, contact sales to upgrade to the Enterprise plan.";
    },
    spendingLimitFieldLabel: function (localizedMoneyString) {
        return "Spending limit (up to  " + localizedMoneyString + " per person)";
    },
    budgetsLimitSubtitle: function (noOfBudgets, maxBudgets) {
        return noOfBudgets + " out of " + maxBudgets;
    },
    budgetsLimitSubtitleTooltip: function (noOfBudgets, maxBudgets) {
        return "You've added " + noOfBudgets + " out of " + maxBudgets + " meal budgets allowed by your  Team plan. To add more members, contact sales to upgrade to the Enterprise plan.";
    },
    budgetLimitSalesModalTitle: function (maxBudgets) {
        return "You've reached your Team plan limit of " + maxBudgets + " meal budgets";
    },
    budgetSalesModalDescription: function () {
        return 'Delete one of your existing meal budgets or contact sales to upgrade to the Enterprise plan which allows unlimited meal budgets.';
    },
    budgetSalesModalContactSalesButtonText: function () { return 'Contact Sales'; },
    budgetSalesModalCancelButtonText: function () { return 'Cancel'; },
    sendEmailNotificationsModalTitle: function () { return 'Send Email Notifications'; },
    sendEmailNotificationsModalDescription: function (teamAccountName) {
        return "Would you like to send email notifications to all eligible members in \"" + teamAccountName + "\"?";
    },
    sendEmailNotificationsModalDescriptionForGroupRestrictedBudget: function () {
        return 'Would you like to send email notifications to all eligible members in selected groups?';
    },
    sendEmailNotificationsModalSendButtonText: function () { return 'Send'; },
    sendEmailNotificationsModalCancelButtonText: function () { return "Don't Send"; },
    sendEmailNotificationsModalSuccessToast: function () {
        return 'Email notifications sent successfully';
    },
    sendEmailNotificationsModalErrorTitleGeneric: function () {
        return 'Unable to Send Notifications';
    },
    sendEmailNotificationsModalErrorTitleBudgetExpired: function () {
        return 'Meal Budget Expired';
    },
    sendEmailNotificationsModalErrorDescriptionGeneric: function () {
        return "We couldn't send the email notifications. Please refresh the page and check the meal budget details.";
    },
    sendEmailNotificationsModalErrorDescriptionBudgetExpired: function () {
        return "We couldn't send the email notifications because the meal budget already expired. Please check the meal budget details.";
    },
    sendEmailNotificationsModalErrorAcknowledgedButton: function () { return "Got it"; },
    budgetList: {
        viewMoreOptionSendEmail: function () { return "Send Email Notification"; },
        viewMoreOptionEdit: function () { return "Edit"; },
        viewMoreOptionDelete: function () { return "Delete"; },
    },
};
export default BudgetStrings;
